import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notify-no-tax-only',
  templateUrl: './notify-no-tax-only.component.html',
  styleUrls: ['./notify-no-tax-only.component.scss']
})
export class NotifyNoTaxOnlyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
